import { localDateToUtc } from "app/utils/timezone";

// Combines a "yyyy-MM-dd" date and an "HH:mm" time (both in the viewer's local
// timezone) into the UTC ISO string the API expects for an appointment start time.
export const combineDateAndTimeToUtc = (dateStr: string, timeStr: string): string => {
  const [year, month, day] = dateStr.split("-").map(Number);
  const [hours, minutes] = timeStr.split(":").map(Number);
  const combinedDate = new Date(year, month - 1, day, hours, minutes);
  return localDateToUtc(combinedDate);
};
